
import React from 'react'
import { createUseStyles, useTheme } from 'react-jss'

import View from './View'

const useStyles = createUseStyles(theme => ({
  root: {
    display: 'none',
    '@media(min-width: 1000px)': {
      position: 'absolute',
      display: 'block',
      width: '100%',
      bottom: '40%',
      //top: 0,
      zIndex: 0,
    }
  },
  svg: {
    width: '100vw',
  }
}))

function Background (props) {
  const theme = useTheme()
  const styles = useStyles({ ...props, theme })
  const rootStyles = props.className ? props.className : styles.root
  return (
    <View className={rootStyles} >
      <svg className={styles.svg} viewBox="0 0 375 260" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path 
          d="M43.9541 -1.96677C43.4942 7.73659 45.5744 17.3909 49.9876 26.0343L54.426 34.5181C88.9384 100.598 140.299 156.292 203.264 195.913C266.229 235.535 338.543 257.664 412.82 260.041L416.693 260.164C426.487 260.564 436.212 258.345 444.874 253.734C453.535 249.123 460.823 242.286 465.992 233.922L581.178 42.9183C586.303 34.6261 589.164 25.1259 589.474 15.3727C589.784 5.61944 587.532 -4.04326 582.944 -12.6442L480.12 -210.577C475.493 -219.253 468.654 -226.539 460.303 -231.691C451.952 -236.842 442.387 -239.674 432.588 -239.897L428.714 -240.021C354.38 -242.311 280.767 -224.736 215.405 -189.093C150.043 -153.45 95.2756 -101.018 56.7042 -37.1574L51.736 -28.9725C46.881 -20.7881 44.2013 -11.4889 43.9541 -1.96677Z" 
          fill={theme.colors.secondary}
        />
        <path 
          d="M413.09 121.678C409.631 130.756 403.864 138.773 396.363 144.93L388.903 150.931C330.846 197.698 261.5 228.208 187.944 239.346C114.389 250.484 39.26 241.851 -29.7711 214.329L-33.3704 212.893C-42.5071 209.343 -50.5333 203.42 -56.6286 195.731C-62.7239 188.041 -66.6697 178.86 -68.0628 169.127L-97.2624 -52.0012C-98.644 -61.6509 -97.4677 -71.5026 -93.8518 -80.5661C-90.2359 -89.6296 -84.3079 -97.5856 -76.6634 -103.634L96.7291 -243.938C104.44 -250.04 113.621 -253.984 123.336 -255.366C133.05 -256.748 142.949 -255.519 152.02 -251.806L155.62 -250.37C224.669 -222.745 285.112 -177.201 330.769 -118.395C376.426 -59.5893 405.658 10.3686 415.475 84.3247L416.756 93.8133C417.933 103.256 416.671 112.851 413.09 121.678Z" 
          fill={theme.colors.primary}
        />
      </svg>
    </View>
  )
}

export default Background